import request from '../utils/request'

export function getCastingNoticeRegions() {
  return request({ url: '/api/admin/casting-notice/regions', method: 'get' })
}

export function publishCastingNotice(data) {
  return request({ url: '/api/admin/casting-notice/publish', method: 'post', data })
}

export function updateCastingNotice(id, data) {
  return request({ url: `/api/admin/casting-notice/${id}`, method: 'put', data })
}

export function getAdminCastingNoticeDetail(id) {
  return request({ url: `/api/admin/casting-notice/${id}`, method: 'get' })
}

export function getCastingNoticeApplications(noticeId, params) {
  return request({ url: `/api/admin/casting-notice/${noticeId}/applications`, method: 'get', params })
}

export function getCastingNoticeApplicationDetail(applicationId) {
  return request({ url: `/api/admin/casting-notice/applications/${applicationId}`, method: 'get' })
}

export function updateCastingNoticeApplication(data) {
  return request({ url: '/api/admin/casting-notice/applications/update', method: 'post', data })
}

export function getCastingNoticeArtists(noticeId, params) {
  return request({ url: `/api/admin/casting-notice/${noticeId}/artists`, method: 'get', params })
}

export function getCastingNoticeArtistDetail(noticeId, artistId) {
  return request({ url: `/api/admin/casting-notice/artists/${artistId}`, method: 'get', params: { noticeId } })
}

export function createCastingNoticeInvitation(data) {
  return request({ url: '/api/admin/casting-notice/invitation/create', method: 'post', data })
}

export function validateCastingNoticeInvitation(noticeId, artistId) {
  return request({
    url: '/api/admin/casting-notice/invitation/validate',
    method: 'get',
    params: { noticeId, artistId }
  })
}

export function cancelCastingNoticeInvitation(noticeId, invitationId) {
  return request({
    url: `/api/admin/casting-notice/invitation/cancel/${invitationId}`,
    method: 'post',
    params: { noticeId }
  })
}

export function getCastingNoticeInvitations(noticeId, params) {
  return request({ url: `/api/admin/casting-notice/${noticeId}/invitations`, method: 'get', params })
}

export function updateAdminOrderFulfillment(data) {
  return request({ url: '/api/admin/platform/orders/fulfillment/update', method: 'post', data })
}

export function updateAdminOrderSettlement(data) {
  return request({ url: '/api/admin/platform/orders/settlement/update', method: 'post', data })
}

export function saveAdminMerchantOrderReview(data) {
  return request({ url: '/api/admin/platform/orders/review/save', method: 'post', data })
}

export function approveAdminArtistCloseOrder(data) {
  return request({ url: '/api/admin/platform/orders/close-request/approve', method: 'post', data })
}

export function rejectAdminArtistCloseOrder(data) {
  return request({ url: '/api/admin/platform/orders/close-request/reject', method: 'post', data })
}
